import styled from 'styled-components';
import Dropdown_back from '../../../assests/images/nav-dropdown-back.webp';

export const CustomeDropmain = styled.div`
    display: flex;
    align-items: center;
    column-gap: 22px; 
   
    @media screen and (max-width:1440px) {
        column-gap: 20px;
     }     
     @media screen and (max-width:1280px) {
        column-gap: 14px;
     } 
     @media screen and (max-width:1024px) {
        flex-wrap: wrap;
    } 

    .nav-item{
        @media screen and (max-width:1024px) {
            width:100%;
            padding:5px 0;
        }
        .nav-link{
            color: #fff;
            
        }
    } 
    .active.nav-item.dropdown:before {
        background: #ffff;
        width: 100%;
        height: 2px;
        content: "";
        bottom: 0;
        position: absolute;
          @media screen and (max-width:1024px) {
            display:none;
          }
    }
    .dropdown-menu{
        background-image:url(${Dropdown_back});
        background-size: 100% 100%;
        background-repeat: no-repeat;
        box-shadow: 0px 5px 20px #0000001A;
        border-radius: 15px;
        opacity: 1;
        margin-top: 0;
        padding: 10px 26px 10px 10px;
        border:none;
        @media screen and (max-width:1024px) { 
            background-image:none;
            padding: 16px 0 0 18px;
            margin-right: 16px;
            position: relative !important;
            max-width: 290px; 
        }
        &:before{
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.5);
            backdrop-filter: blur(75px);
            -webkit-backdrop-filter: blur(75px);
            border-radius: 15px;
            z-index: -1;
            @media screen and (max-width:1024px) { 
                display:none;
            }
        }
    }
    &:hover{
        .basic-nav-dropdown{
            display: block;
        }
    }
    .basic-nav-dropdown{
        display: none;
    }
    .dropdown-toggle:after {
        border-bottom: 0;
        border-left: 5px solid #0000;
        border-right: 5px solid #0000;
        border-top: 5px solid;
        content: "";
        display: inline-block;
        margin-left: 5px;
        vertical-align: middle;
        top: 0px;
        position: relative;
 
    }
    .active.nav-item .nav-link:before {
        background: #fff;
        position: absolute;
        width: 100%;
        height: 2px;
        content: "";
        bottom: 0;
           @media screen and (max-width:1024px) { 
                display:none;
            }
    }

`;
export const NavcustomeDropdown = styled.div`

`;
export const Drodownitemlist = styled.div`
    display: flex;
    align-items: stretch;

    @media screen and (max-width:1024px) {
        flex-wrap: wrap-reverse;
     }
`;
export const DropdownImage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #FFFFFF;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 15px;
    padding: 16px;
    row-gap: 20px;
    @media screen and (max-width:1024px) {
        background: transparent;
        box-shadow: none;
        padding: 16px 0;
        img{
            display:none;
        }
    }
    .donate-now-btn{
        @media screen and (max-width:991px) {
            padding: 10px 20px;
            font-size: 16px;
        }
    }
`;


export const DropdownItem = styled.div`
    padding-left: 24px;
    @media screen and (max-width:991px) {
        padding-left: 0px;
        width: 100%;
    }
    &.border-left-white{
        column-count: 2;
        position: relative;
        column-gap: 44px;
        @media screen and (max-width:991px) {
            column-count: 1;
            column-gap: 0px;
        }

        &:before{
            content: '';
            width: 1px;
            height: 100%;
            background: #fff;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 48%;
            right: 0;
            z-index: -1;
            margin: 0 20px;
            transform: translateX(-50%);
        }
    }
    
    .dropdown-item{
        padding: 0;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 15px;
        background-color: transparent;
        color: #000000;

        &:last-child{
            margin-bottom: 0;
        }
        &:hover{
            color: #000;
            background-color: transparent;
        }
    }
`;
export const CenterMenu = styled.div`
    display: flex;
    align-items: center;
    width:100%;
`;